/*
  The purpose of this file is generate/introduce a toolbelt (Similar to loadash, Ramda, RxJS)
  following the DRY principle and functional programming practices
*/

/*
 Composition functions
*/

/*
  Pipe is a function to create composition of functions (using map, filter, sort, etc)
  Usage example: https://www.freecodecamp.org/news/pipe-and-compose-in-javascript-5b04004ac937/
  External resources: https://medium.com/javascript-scene/tagged/functional-programming
*/
export const pipe = (...fns) => (x) => fns.reduce((v, f) => f(v), x)

export const compose = (...fns) => (x) => fns.reduceRight((v, f) => f(v), x)

export const map = (f) => (arr) => arr.reduce((acc, x) => [...acc, f(x)], [])

export const filter = (f) => (arr) => arr.reduce((acc, x) => f(x) ? [...acc, x] : acc, [])

export const pluck = (str) => (arr) => arr.reduce((acc, x) => [...acc, {[str]: x[str]}], [])

export const sort = (fn) => (arr) => arr.reduce(insertSortedValue(fn), [])

/*
  General DOM functions
  Use these functions to select, handle html elements (similar to jQuery)
*/

//Apply/Loop function to a group of html elements
export const mapDOMElements = (fn) => (items) => [...items].forEach(fn)

export const childOf = (c, p) => {
    while ((c = c.parentNode) && c !== p);
    return !!c;
}

export const selectAll = (query, item = document) => item.querySelectorAll(query)

export const selectArr = (query, item = document) => [].slice.call(item.querySelectorAll(query))

export const select = (item = document, query) => item.querySelector(query)

export const selectDoc = (query, item = document) => item.querySelector(query)

export const value = (query, item = document) => item.querySelector(query).value

//General query for elements equivalent to $()
export const getElems = (query, item = document) => [...item.querySelectorAll(query)]

export const dataValue = ({dataset}) => (id) => dataset[id]

/*
  General DOM functions
  Use these functions to update html elements (similar to jQuery)
*/
export const removeAttribute = (tag) => (item) => item.removeAttribute(tag)

export const closest = (item) => (query) => item.closest(query)

export const remove = (item) => item.parentNode.removeChild(item)

export const nextSibling = (item) => item.nextElementSibling

export const prevSibling = (item) => item.previousElementSibling

export const toggleAttr = (item, attr) => item.toggleAttribute(attr)

export const setAttr = (attr, value) => (item) => item.setAttribute(attr, value)

export const getAttr = (attr) => (item) => item.getAttribute(attr)

export const submit = (item) => item.submit(item)

export const toggleClass = (item, cls) => item.classList.toggle(cls)

export const setText = (item) => (text) => item.innerText = text

export const setHtml = (item) => (html) => item.innerHTML = html

export const opacity = (value) => (item) => item.style.opacity = `${value}`

export const styles = (elem, styles) => elem.setAttribute("style", Object.entries(styles).map(([key, value]) => `${key}: ${value};`).join(' '))

/*
jpgg
*/
export const hasClass = (target, className) => new RegExp('(\\s|^)' + className + '(\\s|$)').test(target.className);

export const isVisible = elem => !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length) // source (2018-03-11): https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js

export const removeClassAll = (list, cls) => list.map(l => l.classList.remove(cls))

export const addClassAll = (list, cls) => list.map(l => l.classList.add(cls))

export const addClass = (e, cls) => !hasClass(e, cls) ? e.classList.add(cls): false;

export const removeClass = (e, cls) => hasClass(e, cls) ? e.classList.remove(cls): false;

export const toggleClassAll = (items, cls) => [].slice.call(items).map(item => item.classList.toggle(cls))

export const event = (elem, event, func) => {
    if(typeof elem == 'object') {
        elem ? elem.addEventListener(event, func) : console.log('Invalid element to apply ' + event + ': ' + func)
    } else {
        console.log(elem)
    }
};

export const ajax = async (method, url, data = {}, contentType = 'application/json', xhttp = null) => {
    return new Promise(resolve => {
        if (!xhttp) {
            xhttp = new XMLHttpRequest();
        }
        xhttp.onreadystatechange = function () {
            if (xhttp.readyState === 4) {
                resolve(JSON.stringify({
                    status: xhttp.status,
                    response: xhttp.responseText
                }));
            }
        };

        xhttp.open(method, url, true);
        if (method === 'POST' && data) {
            xhttp.setRequestHeader('Content-type', contentType)
            xhttp.send(data);
        } else {
            xhttp.send();
        }

        return xhttp;
    });
}

export const observeAdd = async (container, callback) => {
    new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                let nodes = [].slice.call(mutation.addedNodes);
                if (nodes.length > 0) {
                    callback(nodes)
                }
            }
        }
    }).observe(container, {attributes: true, childList: true, subtree: true});
}

export const observeRemove = async (container, callback) => {
    new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                let nodes = [].slice.call(mutation.removedNodes);
                if (nodes.length > 0) {
                    callback(nodes)
                }
            }
        }
    }).observe(container, {attributes: true, childList: true, subtree: true});
}

/**
 *
 * @param container
 * @param callback
 * @returns {Promise<void>}
 */
export const observeAll = (container, callback) => {
    new MutationObserver((mutationsList, observer) => {
        callback(mutationsList);
    }).observe(container, { attributes: true, childList: true, subtree: true });
};

export const cartesian = (...a) => a.reduce((a, b) => a.flatMap(d => b.map(e => [d, e].flat())));

/*
  General purpose functions
  Use these functions to apply certain operation in your context
*/
export const count = (str) => str.length

export const goTo = (URL) => window.location.href = URL

export const insertSortedValue = (fn) => (arr, value) => [...arr.filter(n => !fn(n, value)), value, ...arr.filter(n => fn(n, value))]

export const serialize = (form) => Array.from(new FormData(form), e => e.map(encodeURIComponent).join('=')).join('&')

export const getQueryValue = (value) => (new URLSearchParams(window.location.search)).get(value)

export const asyncForEach = async (array, callback) => {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
}
